var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('LoadingContainer'):_c('div',[_c('FormPanel',{attrs:{"initial":_vm.contentRegistration.attributes,"headline":"Edit Registration","errors":_vm.errors,"company-id":_vm.contentRegistration.attributes.company_id,"content-registration-categories":_vm.contentRegistrationCategories,"edit":true},on:{"submit":_vm.submit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }